import { LatinCountingWord } from "../LatinWord";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const LATIN_COUNTING_WORDS: Array<LatinCountingWord> = [
  {
    type: "countingWord",
    latin: "ūnus",
    conjugations: ["ūnus", "ūna", "ūnum"],
    dutch: "één; enig",
  },
  {
    type: "countingWord",
    latin: "duo",
    conjugations: ["duo", "duae", "duo"],
    dutch: "twee",
  },
  {
    type: "countingWord",
    latin: "trēs",
    conjugations: ["trēs", "tria", "trium"],
    dutch: "drie",
  },
  {
    type: "countingWord",
    latin: "quattuor",
    dutch: "vier",
  },
  {
    type: "countingWord",
    latin: "quīnque",
    dutch: "vijf",
  },
  {
    type: "countingWord",
    latin: "sex",
    dutch: "zes",
  },
  {
    type: "countingWord",
    latin: "septem",
    dutch: "zeven",
  },
  {
    type: "countingWord",
    latin: "octō",
    dutch: "acht",
  },
  {
    type: "countingWord",
    latin: "novem",
    dutch: "negen",
  },
  {
    type: "countingWord",
    latin: "decem",
    dutch: "tien",
  },
  {
    type: "countingWord",
    latin: "vīgintī",
    dutch: "twintig",
  },
  {
    type: "countingWord",
    latin: "centum",
    dutch: "honderd",
  },
  {
    type: "countingWord",
    latin: "mīlle",
    dutch: "duizend",
  },
  {
    type: "countingWord",
    latin: "... mīlia (mīl-ium, o)",
    dutch: "...duizend",
  },
  // {
  //   type: "countingWord",
  //   latin: "",
  //   conjugations: ["", "", ""],
  //   dutch: "",
  // },
];

export function searchLatinCountingWord(latin: string): LatinCountingWord {
  const results = LATIN_COUNTING_WORDS.filter((word) => word.latin === latin);
  if (results.length !== 1) {
    console.error(results);
    throw new Error(`No single Latin counting word found for: "${latin}"`);
  }
  return results[0];
}